import { render, staticRenderFns } from "./UserDetailForm.vue?vue&type=template&id=93b483bc&scoped=true"
import script from "./UserDetailForm.vue?vue&type=script&lang=js"
export * from "./UserDetailForm.vue?vue&type=script&lang=js"
import style0 from "./UserDetailForm.vue?vue&type=style&index=0&id=93b483bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b483bc",
  null
  
)

export default component.exports